module.exports = __webpack_public_path__ + "img/编组 4.73778180.png";